define('score_bootstrap/Models/Comments/CommentsRequest',[], function () {
    "use strict";

    function CommentsRequest(componentId, pageNumber, pageSize, pagingEnabled, orderByAscending, cascadedRepliesDepth, userLanguage, rootId) {
        var instance = {
                componentId: componentId,
                pageNumber: pageNumber,
                pageSize: pageSize,
                pagingEnabled: pagingEnabled,
                orderByAscending: orderByAscending,
                cascadedRepliesDepth: cascadedRepliesDepth,
                userLanguage: userLanguage,
                rootId: rootId
            };

        Object.defineProperties(this, {
            componentId: {
                enumerable: true,
                get: function () { return instance.componentId; },
                set: function (value) {
                    instance.componentId = value;
                }
            },
            pageNumber: {
                enumerable: true,
                get: function () { return instance.pageNumber; },
                set: function (value) {
                    instance.pageNumber = value;
                }
            },
            pageSize: {
                enumerable: true,
                get: function () { return instance.pageSize; },
                set: function (value) {
                    instance.pageSize = value;
                }
            },
            pagingEnabled: {
                enumerable: true,
                get: function () { return instance.pagingEnabled; },
                set: function (value) {
                    instance.pagingEnabled = value;
                }
            },
            orderByAscending: {
                enumerable: true,
                get: function () { return instance.orderByAscending; },
                set: function (value) {
                    instance.orderByAscending = value;
                }
            },
            cascadedRepliesDepth: {
                enumerable: true,
                get: function () { return instance.cascadedRepliesDepth; },
                set: function (value) {
                    instance.cascadedRepliesDepth = value;
                }
            },
            userLanguage: {
                enumerable: true,
                get: function () { return instance.userLanguage; },
                set: function (value) {
                    instance.userLanguage = value;
                }
            },
            rootId: {
                enumerable: true,
                get: function () { return instance.rootId; },
                set: function (value) {
                    instance.rootId = value;
                }
            },
            userLocalTimeNow: {
                enumerable: true,
                get: function() {
                     return new Date().toString();
                }
            }
        });
    }

    return CommentsRequest;
});
